/* Keyboard support for the existing District navigation and native country disclosure. */
(function(){
'use strict';
function init(){
var menu=document.getElementById('menu'),opener=document.querySelector('.toggle-menu'),lastOpen=false;
function isOpen(){return document.body.classList.contains('panel-open')||document.documentElement.classList.contains('panel-open')}
function sync(){
var open=isOpen();
if(opener)opener.setAttribute('aria-expanded',String(open));
if(menu){menu.setAttribute('aria-hidden',String(!open));menu.inert=!open}
if(!lastOpen&&open&&menu){var close=menu.querySelector('.menu-link');if(close)close.focus()}
if(lastOpen&&!open&&opener)opener.focus();
lastOpen=open;
}
sync();
new MutationObserver(sync).observe(document.body,{attributes:true,attributeFilter:['class']});
new MutationObserver(sync).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
document.addEventListener('click',function(e){
document.querySelectorAll('.wg-country[open]').forEach(function(d){if(!d.contains(e.target))d.removeAttribute('open')});
});
document.addEventListener('keydown',function(e){
if(e.key==='Escape'){
document.querySelectorAll('.wg-country[open]').forEach(function(d){d.removeAttribute('open');d.querySelector('summary').focus()});
if(isOpen()&&menu){var close=menu.querySelector('.menu-link');if(close){e.preventDefault();close.click()}}
return;
}
if(e.key!=='Tab'||!menu||!isOpen())return;
var items=Array.prototype.filter.call(menu.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]'),function(el){return el.tabIndex>=0&&!el.disabled&&el.getClientRects().length});
if(!items.length)return;
var first=items[0],last=items[items.length-1];
if(e.shiftKey&&(document.activeElement===first||document.activeElement===menu)){e.preventDefault();last.focus()}
else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
